import { Button, Flex, Text } from '@chakra-ui/react';

import { Link } from '@/components/common/Link';

export const SuccessStep = () => {
  return (
    <Flex direction="column" gap="8" w="full">
      <Flex direction="column" w="full">
        <Text color="primary.500" fontWeight="bold" fontSize="lg">
          Senha Recuperada!
        </Text>
        <Text>Agora, basta logar na sua conta com a nova senha escolhida.</Text>
      </Flex>

      <Button as={Link} to="/login" variant="@primary" w="100%">
        Ir para login
      </Button>
    </Flex>
  );
};
